import { ShieldCheck, Sparkles } from 'lucide-react'
import { Button } from '@teach/ui'
import { useMessages } from '@/i18n'
import { messages } from '../messages'
import type { OAuthPending } from '../types'

interface Props {
  pending: OAuthPending
  busy: boolean
  onApprove: () => void
  onDeny: () => void
}

// Rich consent card: who is asking + what they get + security note + actions.
export const ConsentCard = ({ pending, busy, onApprove, onDeny }: Props) => {
  const m = useMessages(messages)
  const name = pending.client_name ?? 'Claude'
  const access = [m.accessEdit, m.accessPublish]
  return (
    <div className="flex min-h-dvh items-center justify-center bg-background p-6">
      <div className="w-full max-w-md rounded-2xl border border-border bg-card p-6 shadow-sm">
        <div className="mb-4 flex items-center gap-3">
          <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-brand/15">
            <Sparkles className="h-5 w-5 text-brand" />
          </div>
          <div>
            <h1 className="text-lg font-bold text-foreground">{m.requestsAccess(name)}</h1>
            <p className="text-sm text-muted-foreground">{m.toAuthorAccount}</p>
          </div>
        </div>

        <p className="mb-3 text-sm text-foreground">{m.consentLead}</p>
        <ul className="mb-4 space-y-2">
          {access.map((item) => (
            <li key={item} className="flex items-start gap-2 text-sm text-foreground">
              <ShieldCheck className="mt-0.5 h-4 w-4 shrink-0 text-success" />
              {item}
            </li>
          ))}
        </ul>

        <p className="mb-5 text-xs text-muted-foreground">{m.consentRevokeNote}</p>

        <div className="flex gap-2">
          <Button variant="ghost" className="flex-1" onClick={onDeny} disabled={busy}>
            {m.deny}
          </Button>
          <Button className="flex-1" onClick={onApprove} disabled={busy}>
            {m.allow}
          </Button>
        </div>
      </div>
    </div>
  )
}
